import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { FilterItem } from '../lib';

interface FilterChipsProps {
  items: FilterItem[];
  toggleItem: (value: string) => void;
}

export const FilterChips = ({ items, toggleItem }: FilterChipsProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {items
        .filter((f) => f.selected)
        .map((f) => (
          <Chip
            key={`tag-${f.value}`}
            label={`${t('pages.playlists.list.filter_chips.tag_prefix')} ${f.label}`}
            color="primary"
            onDelete={() => {
              // Toggle off this tag
              toggleItem(f.value);
            }}
          />
        ))}
    </Box>
  );
};
